<script setup>

</script>

<template>
<div>
  <h1>請以正確的方式進行進入系統</h1>
</div>
</template>

<style scoped>

</style>
